module.exports = __webpack_public_path__ + "static/media/cldc9_4.08830290.jpg";